import { resolvePlaceholders } from './placeholders';

/**
 * Resolves every placeholder of an already built recipe, returning new objects
 * so the client definitions — which are shared module-level constants — are
 * never mutated. Only snippets carry placeholders: every other text field is a
 * translation id resolved by the component that renders it.
 *
 * @param {Array} sections - sections returned by a client's buildSections
 * @param {Object} values - { serverUrl, instanceUrl, apiToken, username, password }
 * @returns {Array} the same sections with every snippet placeholder replaced
 */
const resolveRecipe = (sections, values) => sections.map((section) => ({
  ...section,
  blocks: section.blocks.map((block) => (
    block.snippet === undefined
      ? { ...block }
      : { ...block, snippet: resolvePlaceholders(block.snippet, values) }
  ))
}));

export default resolveRecipe;
